import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'

import { PEN_5216_FLAG } from '../components/Pen5216Wrapper'

export const useTrackPen5216Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(PEN_5216_FLAG)
  }, [])
}
